<script setup>
import dayjs from 'dayjs';
import { formatCnj } from '~/utils';
import { useAuthStore } from '~/stores/auth';

const props = defineProps({
  intimacao: {
    required: true,
    type: Object,
  },
});

const authStore = useAuthStore();

function formatDate(value) {
  if (!value) {
    return '-';
  }
  
  // Se já vier formatado como texto (ex: dataEnvioText, dataCriacaoText)
  if (typeof value === 'string' && value.includes('/')) {
    return value;
  }
  
  // Caso contrário, formata usando dayjs
  return dayjs.utc(value).tz(authStore.timeZone).format('DD/MM/YYYY HH:mm');
}
</script>

<template>
  <a-descriptions :column="3" :label-style="{ width: '20%' }" bordered>
    <a-descriptions-item label="Código" :span="3">
      {{ intimacao.codigo }}
      <a-typography-text
        :copyable="{
          text: intimacao.codigo,
        }"
      >
        <template #copyableTooltip="{ copied }">
          <span v-if="!copied" key="copy-tooltip">Copiar</span>
          <span v-else key="copied-tooltip">Copiado!</span>
        </template>
      </a-typography-text>
    </a-descriptions-item>
    <a-descriptions-item label="Processo" :span="3">
      {{ formatCnj(intimacao.processo) }}
    </a-descriptions-item>
    <a-descriptions-item label="Vara" :span="3">
      {{ intimacao.vara || '-' }}
    </a-descriptions-item>
    <a-descriptions-item label="Cliente" :span="3">
      {{ intimacao.cliente || '-' }}
    </a-descriptions-item>
    <a-descriptions-item label="Evento" :span="3">
      {{ intimacao.evento || '-' }}
    </a-descriptions-item>
    <a-descriptions-item label="Prazo" :span="3">
      {{ intimacao.prazo || '-' }}
    </a-descriptions-item>
    <a-descriptions-item label="Tipo de prazo" :span="3">
      {{ intimacao.tipoPrazoText || intimacao.tipoPrazo || '-' }}
    </a-descriptions-item>
    <a-descriptions-item label="Data de envio" :span="3">
      {{ intimacao.dataEnvioText || formatDate(intimacao.dataEnvio) }}
    </a-descriptions-item>
    <a-descriptions-item label="Data de criação" :span="3">
      {{ intimacao.dataCriacaoText || formatDate(intimacao.dataCriacao) }}
    </a-descriptions-item>
  </a-descriptions>
</template>

